export interface ActiveSession {
  id: string;
  device: string;
  created_at: string;
  last_active_at: string;
}

export interface SessionReplacement {
  session_ticket: string;
  session_id: string;
}

export class SessionLimitError extends Error {
  readonly sessions: ActiveSession[];
  readonly ticket: string;

  constructor(sessions: ActiveSession[], ticket: string, message: string) {
    super(message);
    this.name = 'SessionLimitError';
    this.sessions = sessions;
    this.ticket = ticket;
  }
}

export function loginError(data: any): Error {
  if (data.code === 'session_limit_reached' && Array.isArray(data.sessions) && data.session_ticket) {
    return new SessionLimitError(data.sessions, data.session_ticket, data.detail);
  }
  return new Error(data.detail || 'Login failed');
}
